/**
 * REST API base URL.
 * - If REACT_APP_API_URL is set at build time, use it (split frontend/backend deploys).
 * - Ignore localhost URLs in production (Railway sometimes sets a wrong build-time value).
 * - Otherwise in production builds, use same-origin /api (Docker monolith on Railway).
 * - In development, default to local backend.
 */
export function getApiBaseUrl() {
  const env = (process.env.REACT_APP_API_URL || "").trim();
  const prod = process.env.NODE_ENV === "production";
  const localhostish = /localhost|127\.0\.0\.1/i.test(env);
  if (env && !(prod && localhostish)) return env.replace(/\/$/, "");
  if (prod) return "/api";
  return "http://localhost:5000/api";
}
